<template>
  <div class="InputErrors" id="validation-error">
    <span v-if="ins.required !== undefined && !ins.required" class="error-msg">
      Dit veld is verplicht.
    </span>
    <span v-else-if="ins.numeric !== undefined && !ins.numeric" class="error-msg">
      Dit nummer is niet geldig.
    </span>
    <span v-else-if="ins.decimal !== undefined && !ins.decimal" class="error-msg">
      Dit nummer is niet geldig.
    </span>
    <span v-else-if="ins.integer !== undefined && !ins.integer" class="error-msg">
      Dit gehele getal is niet geldig.
    </span>
    <span v-else-if="ins.email !== undefined && !ins.email" class="error-msg">
      Deze email is ongeldig.
    </span>
    <span v-else-if="ins.url !== undefined && !ins.url" class="error-msg">
      Dit domein is ongeldig (verwijder het <b>https://</b> gedeelte).
    </span>
    <span v-else-if="ins.alpha !== undefined && !ins.alpha" class="error-msg">
      Only alphabetical characters are valid.
    </span>
    <span v-else-if="ins.notLowerThanDefaultValue !== undefined && !ins.notLowerThanDefaultValue" class="error-msg">
      Verkoop Advies Prijs kan niet lager zijn dan de Inkoop Prijs.
    </span>
    <span v-else class="error-msg">
      <slot v-bind="ins"></slot>
    </span>
  </div>
</template>

<script>

export default {
  props: ['ins']
}

</script>

<style scoped>

.InputErrors span {
}

</style>
